export default {
  IS_NOT_SELECTED: null,
  IS_DISABLED: true,
  IS_NOT_DISABLED: false,
};
